// extracted by mini-css-extract-plugin
export default {"homePage":"-sROvfzggQsbSBbbGMdTxA=="};